import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon, TrendingUpIcon, GraduationCapIcon, GlobeIcon, RocketIcon, NetworkIcon, CircuitBoardIcon, BuildingIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Partners() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const {
    t
  } = useLanguage();
  const partners = [{
    name: 'European Innovation Council',
    typeKey: 'partners.t1',
    icon: SparklesIcon
  }, {
    name: 'Hungarian Investment Agency',
    typeKey: 'partners.t2',
    icon: TrendingUpIcon
  }, {
    name: 'Budapest University of Technology',
    typeKey: 'partners.t3',
    icon: GraduationCapIcon
  }, {
    name: 'EU Digital Alliance',
    typeKey: 'partners.t4',
    icon: GlobeIcon
  }, {
    name: 'Startup Hungary',
    typeKey: 'partners.t5',
    icon: RocketIcon
  }, {
    name: 'V4 Tech Network',
    typeKey: 'partners.t6',
    icon: NetworkIcon
  }, {
    name: 'Digital Europe Programme',
    typeKey: 'partners.t7',
    icon: CircuitBoardIcon
  }, {
    name: 'Central European Tech Hub',
    typeKey: 'partners.t8',
    icon: BuildingIcon
  }];
  return <section id="partners" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border)'
  }} data-id="element-322">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-323">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.45
      }} className="mb-12 sm:mb-16 text-center" data-id="element-324">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-325">
            {t('partners.title')}
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-326">
            {t('partners.desc')}
          </p>
        </motion.div>

        {/* 1 col mobile, 2 col sm, 4 col md+ */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-id="element-327">
          {partners.map((partner, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.35,
          delay: 0.05 + index * 0.04,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} data-id="element-328">
              <div className="h-full rounded-2xl border p-5 sm:p-6 flex flex-row sm:flex-col items-center sm:justify-center gap-4 sm:gap-0 sm:text-center transition-colors hover:bg-[var(--bg-tertiary)]" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-primary)'
          }} data-id="element-329">
                <div className="w-11 h-11 sm:w-12 sm:h-12 sm:mb-4 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(59, 130, 246, 0.1)'
            }} data-id="element-330">
                  <partner.icon className="w-5 h-5 sm:w-6 sm:h-6" style={{
                color: 'var(--accent)'
              }} data-id="element-331" />
                </div>
                <div className="flex flex-col sm:items-center" data-id="element-332">
                  <h3 className="text-sm font-bold mb-0.5 sm:mb-2" style={{
                color: 'var(--text-primary)'
              }} data-id="element-333">
                    {partner.name}
                  </h3>
                  <span className="text-xs" style={{
                color: 'var(--text-muted)'
              }} data-id="element-334">
                    {t(partner.typeKey)}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}